export const addMultichoiceQuestionContinueBtnDataSet = { cy: 'QuestionButtons-multichoice-btn' };
export const addOpenEndedQuestionContinueBtnDataSet = { cy: 'QuestionButtons-open-ended-btn' };
export const addSurveyQuestionContinueBtnDataSet = { cy: 'QuestionButtons-survey-btn' };
